export default {
	init() {
		const $form = $("#mailerlite-form")
		if (!$form.length) return

		const $submit = $form.find("button[type='submit']")
		const defaultBtnHtml = $submit.html()
		const $message = $form.closest(".footer-mailerlite").find(".footer-mailerlite-response")

		$form.on("submit", function (e) {
			e.preventDefault()
			
			const email = ($form.find("input[name='email']").val() || "").trim()
			const name = ($form.find("input[name='name']").val() || "").trim()
			const group_id = ($form.find("input[name='group_id']").val() || "").trim()
			const consentChecked = !!$form.find("input[name='consent']")[0]?.checked
			const nonce = $form.find("input[name='mailerlite-nonce']").val() || ""

			if (!email) {
				$message.text("Vnesite veljaven e-poštni naslov.")
					.removeClass("hidden")
					.addClass("text-red-500")
				return
			}

			if (!consentChecked) {
				$message.text("Pred pošiljanjem morate potrditi soglasje.")
					.removeClass("hidden")
					.addClass("text-red-500")
				return
			}

			$submit.prop("disabled", true).html(defaultBtnHtml + "…")
			$message.text("").removeClass("text-red-500").addClass("hidden")

			$.ajax({
				url: (window.my_ajax_object && window.my_ajax_object.ajax_url) || "/wp-admin/admin-ajax.php",
				method: "POST",
				dataType: "json",
				data: {
					action: "vivi_mailerlite_ajax",
					email,
					name,
					group_id,
					consent: consentChecked ? "1" : "0",
					"mailerlite-nonce": nonce,
				},
			})
			.done(function (res) {
				if (res && res.success) {
					$message.text(res.data && res.data.message ? res.data.message : "Hvala! Uspešno ste prijavljeni.")
						.removeClass("text-red-500 hidden")
					$form.addClass("hidden")
				} else {
					$message.text((res && res.data && res.data.message) ? res.data.message : "Prišlo je do napake. Poskusite znova.")
						.removeClass("hidden")
						.addClass("text-red-500")
				}
			})
			.fail(function () {
				$message.text("Prišlo je do napake. Poskusite znova.")
					.removeClass("hidden")
					.addClass("text-red-500")
			})
			.always(function () {
				$submit.prop("disabled", false).html(defaultBtnHtml)
			})
		})
	}
}
